module.exports = __webpack_public_path__ + "static/media/photo-12.af7d58cb.jpg";